import IconGear from '@adv-mt/mt-svg-icons/lib/Gear.js'
import IconGearAuto from '@adv-mt/mt-svg-icons/lib/GearAuto.js'

const TRANSMISSION_TYPES = {
  AUTOMATIC: 1,
  MANUAL: 2
}

export const ICONS_BY_TRANSMISSION_TYPE = {
  [TRANSMISSION_TYPES.AUTOMATIC]: IconGearAuto,
  [TRANSMISSION_TYPES.MANUAL]: IconGear
}
